import { Injectable } from "@angular/core";
import { StorageType } from "../../constants";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  /**
   * Sets the value oder the given key in the selected storage
   * @param key {@link string} string key
   * @param value T value of any type
   * @param type {@link StorageType} by default the local storage is set
   * @returns value
   */
  setItem<T>(key: string, value: T, type: StorageType = StorageType.Local): T {
    const storage = this.#getStorage(type);
    storage.setItem(key, JSON.stringify(value));
    return value;
  }

  /**
   * Extracts and returns the extracted value from the requested storage or null if not found/
   * @param key {@link string} string key
   * @param type {@link StorageType} by default the local storage is set
   * @returns {@link unknown} | null
   */
  getItem(key: string, type: StorageType = StorageType.Local): unknown | null {
    const storage = this.#getStorage(type);
    const jsonValue: string | null = storage.getItem(key);
    return jsonValue ? JSON.parse(jsonValue) : null;
  }

  /**
   * Checks if the value under the key exists in the selected storage
   * @param key {@link string} string key
   * @param type {@link StorageType} by default the local storage is set
   * @returns {@link boolean}
   */
  containsItem(key: string, type: StorageType = StorageType.Local): boolean {
    const storage = this.#getStorage(type);
    return !!storage.getItem(key);
  }

  /**
   * Removes the value with the provided key form the selected storage
   * @param key {@link string} string key
   * @param type {@link StorageType} by default the local storage is set
   */
  removeItem(key: string, type: StorageType = StorageType.Local): void {
    const storage = this.#getStorage(type);
    storage.removeItem(key);
  }

  #getStorage(type: StorageType): Storage {
    switch (type) {
      case StorageType.Local:
        return localStorage;
      case StorageType.Session:
        return sessionStorage;
    }
  }
}
